import React from "react";
import styles from "./index.module.scss";

interface Props {
  height?: number;
  width?: number;
  flex?: boolean;
}

const BlessSkeletonLoader = ({ height, width, flex }: Props) => {
  return (
    <div
      className={styles.skeletonLoader}
      style={{ height, width, flex: flex ? 1 : undefined }}
    />
  );
};

export default BlessSkeletonLoader;
